import script from "./LiveSportsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsSlider.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsSlider.vue?vue&type=style&index=0&id=00311983&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00311983"]])

export default __exports__